import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { groupByWithoutNullishKeys } from '@paragon/utilities';

import { RootState } from '../store';

export const getBundlesByScheduleGroupGuid = createSelector(
  (state: RootState) => state.scheduleGroups,
  (state: RootState) => state.bundles,

  (scheduleGroups, bundles) => {
    const bundlesByScheduleGroupGuid = groupByWithoutNullishKeys(
      Object.values(bundles),
      (bundle) => bundle.scheduleGroupGuid,
    );
    return mapValues(scheduleGroups, (scheduleGroup) => bundlesByScheduleGroupGuid[scheduleGroup.guid] ?? []);
  },
);
